<template>
  <div style="padding-bottom: 150px" class="centered">
    <div class="center" style="" v-if="finshedLoad && dataTable.length > 0">
      <div class="header-title">
        <p class="title_">
          <b-icon
            style="margin-right: 10px"
            class="icon-beaut"
            icon="chevron-left"
            font-scale="1"
            @click="() => this.$router.go(-1)"
          ></b-icon>
          {{ currentCostCenter }}
        </p>
        <el-input
          style="width: 300px; margin-right: 150px"
          v-model="search"
          size="medium"
          placeholder="Fazer busca"
          clearable
        >
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input>
      </div>
      <div class="table-teste" v-if="finshedLoad && dataTable.length > 0">
        <el-table
          :data="handleSearch"
          @row-click="rowClicked"
          ref="tableData"
          clickable-rows
          :header-cell-style="{ color: '#333' }"
        >
          <el-table-column type="expand">
            <template slot-scope="props">
              <el-table
                style="font-size: 12px; margin-left: 50px"
                :data="props.row.distribution"
                :header-cell-style="{ color: '#333' }"
              >
                <el-table-column
                  label="Colaborador"
                  prop="name"
                  width="200"
                ></el-table-column>
                <el-table-column
                  label="Valor alocado"
                  prop="value_allocated"
                  width="200"
                >
                  <template slot-scope="scope">
                    <span v-if="scope.row.value_allocated">{{
                      scope.row.value_allocated.toLocaleString(
                        constants.language,
                        {
                          style: "currency",
                          currency: constants.currency,
                        }
                      )
                    }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="Alocação" prop="total_cost" width="200">
                  <template slot-scope="scope">
                    <span v-if="scope.row.percentage_allocated"
                      >{{ scope.row.percentage_allocated.toFixed(2) }}%</span
                    >
                  </template>
                </el-table-column>
              </el-table>
            </template>
          </el-table-column>
          <el-table-column label="Mês" prop="month" width="200">
            <template slot-scope="scope">
              <span class="cursor-pointer">{{
                period || dayjs(scope.row.month).format("MM/YYYY")
              }}</span>
            </template>
          </el-table-column>
          <el-table-column label="Custo total" prop="total_used" width="600">
            <template slot-scope="scope">
              <span class="cursor-pointer" v-if="scope.row.total_used">{{
                scope.row.total_used.toLocaleString(constants.language, {
                  style: "currency",
                  currency: constants.currency,
                })
              }}</span>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination">
          <Paginator
            :pageSize="pageSize"
            :total="dataTableTemp.length"
            :start="(page - 1) * pageSize + 1"
            :end="
              page * pageSize > dataTableTemp.length
                ? dataTableTemp.length
                : (page - 1) * pageSize + pageSize
            "
            @set-page-size="setCurrentPageSize"
          />
          <el-pagination
            :hide-on-single-page="true"
            layout="prev, pager, next"
            :total="dataTableTemp.length"
            :page-size="pageSize"
            :current-page="page"
            @current-change="setPage"
          />
        </div>
      </div>
    </div>
    <div style="font-size: 14px; padding: 25px" v-else>
      <el-skeleton :rows="8" animated v-if="!finshedLoad" style="width: 100%" />
      <div class="header-title">
        <p class="title_">
          <b-icon
            style="margin-right: 10px"
            class="icon-beaut"
            icon="chevron-left"
            font-scale="1"
            @click="() => this.$router.go(-1)"
          ></b-icon>
          {{ currentCostCenter }}
        </p>
      </div>
      <span class="no-content-text">
        {{
          dataTable.length === 0 && finshedLoad
            ? "Sem dados de rateios para exibir."
            : ""
        }}
      </span>
    </div>
  </div>
</template>

<style scoped>
.cursor-pointer {
  cursor: pointer !important;
}
</style>

<script>
import { mapActions, mapGetters } from "vuex";
import store from "../utils/store";
import api from "../utils/api";
import dayjs from "../utils/dayjs";

import constants from "../utils/constants";
import Paginator from "../components/Paginator.vue";

export default {
  name: "LocationApportionment",
  components: {
    Paginator,
  },
  data() {
    return {
      constants: constants,
      locationId: null,
      dayjs: dayjs,
      finshedLoad: false,
      page: 1,
      pageSize: 10,
      dataTable: [],
      dataTableTemp: [],
      search: "",
      currentCostCenter: "",
      currentCostCenterId: "",
      period: "",
      searchColumns: ["period", "total_used"],
    };
  },
  computed: {
    ...mapGetters(["getLocationId"]),
    pagedTableData() {
      const data = this.dataTableTemp.slice(
        this.pageSize * this.page - this.pageSize,
        this.pageSize * this.page
      );
      if (data.length === 0) {
        this.page = 1;
      }
      return data;
    },
    handleSearch() {
      if (this.search.length > 0) {
        this.dataTableTemp = this.dataTable.filter((item) => {
          for (let value of this.searchColumns) {
            if (
              String(item[value])
                .toLowerCase()
                .includes(this.search.toLowerCase())
            )
              return item;
          }
        });
      } else {
        this.dataTableTemp = this.dataTable;
      }
      return this.pagedTableData;
    },
  },
  async created() {
    this.updateNavCurrentIndex("2");
    this.finshedLoad = false;
    const array_teste = store.state.navItems.map((e) => {
      if (
        e.route === "/" ||
        e.route === "/upload" ||
        e.route === "/apportionmentBylocation"
      ) {
        return { ...e, disabled: false, route: "/apportionmentBylocation" };
      } else {
        return { ...e, disabled: false };
      }
    });
    this.locationId = this.getLocationId;
    this.updateNavItems_(array_teste);
    await this.getInformations();
    this.finshedLoad = true;
    this.dataTableTemp = this.dataTable;
  },
  watch: {
    getLocationId: function (val) {
      this.locationId = val;
    },
  },
  methods: {
    ...mapActions(["updateNavItems", "updateNavCurrentIndex"]),
    setPage(val) {
      this.page = val;
    },
    setCurrentPageSize(pageSize) {
      this.setPage(1);
      this.pageSize = pageSize.size;
    },
    updateNavItems_(array_teste) {
      this.updateNavItems(array_teste);
    },
    async getInformations() {
      this.currentCostCenterId = this.$route.params.id;
      const { data } = await api.get(
        `/findOneCostCenter/${this.currentCostCenterId}`
      );
      this.dataTable = data.apportionments.map((e) => {
        return { ...e, period: this.dayjs(e.month).format("MM/YYYY") };
      });
      this.currentCostCenter = data.name;
    },
    rowClicked(row) {
      this.$refs.tableData.toggleRowExpansion(row);
    },
  },
};
</script>
